import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_LB_COEFFICIENT } from 'api/notificationManager/methods';

export default class LeaderBoardCoefficientRequest extends WsBaseRequest {
  constructor(data: any) {
    super(API_METHOD_LB_COEFFICIENT, data);
  }
}
